"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.nodeTypes = exports.FinalNode = void 0;
exports.FinalNode = '0';
exports.nodeTypes = {
    question: 'Question',
    group: 'QuestionGroup',
};
